module.exports = __webpack_public_path__ + "static/media/bg1.3290f857.png";